import React, { useState, useEffect } from "react";
import { AccountMenu } from "./Component/AccountMenu";
import "../node_modules/video-react/dist/video-react.css";
import { useUser } from "./Provider/UserProvider";
import "./Component/Asset.css";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { useParams } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
import { Grid, Button } from "@mui/material";
import { API_DOMAIN_URL } from "./Common";

export function HistoryDetail() {
  const { user } = useUser();
  const [reports, setReports] = useState();
  const navigate = useNavigate();
  let params = useParams();
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");

  const getReportJobinTargetYearMonth = (orgUserId, from, to) => {
    // get organization users data
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetReportJobInTargetYearMonth?code=${code}&UserId=${orgUserId}&From=${from}&To=${to}`;
    //console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        setReports(response);
      })
      .catch(() => {
        console.log("error ocuuerd in fetching");
      });
  };

  //日付から文字列に変換する関数
  const getStringFromDate = (date) => {
    // 日本時間に修正
    date.setHours(date.getHours());

    var year_str = date.getFullYear();
    //月だけ+1すること
    var month_str = 1 + date.getMonth();
    var day_str = date.getDate();
    var hour_str = date.getHours();
    var minute_str = date.getMinutes();
    var second_str = date.getSeconds();

    month_str = ("0" + month_str).slice(-2);
    day_str = ("0" + day_str).slice(-2);
    hour_str = ("0" + hour_str).slice(-2);
    minute_str = ("0" + minute_str).slice(-2);
    second_str = ("0" + second_str).slice(-2);

    let format_str = "YYYY/MM/DD hh:mm:ss";
    format_str = format_str.replace(/YYYY/g, year_str);
    format_str = format_str.replace(/MM/g, month_str);
    format_str = format_str.replace(/DD/g, day_str);
    format_str = format_str.replace(/hh/g, hour_str);
    format_str = format_str.replace(/mm/g, minute_str);
    format_str = format_str.replace(/ss/g, second_str);

    return format_str;
  };

  useEffect(() => {
    if (!params || !params.OrgUserId || !params.YearMonth) {
      console.log("requiered url params does not supplied");
      navigate("/");
      return;
    }

    let year = params.YearMonth.slice(0, 4);
    let month = params.YearMonth.slice(4, 6);
    setYear(year);
    setMonth(month);

    // 対象月の月初日と月末の日時を取得
    let yearMonthFrom = `${year}/${month}`; // ここ
    const yearInt = parseInt(year);
    const monthInt = parseInt(month);
    let lastDate = new Date(yearInt, monthInt, 0);
    lastDate.setHours(23, 59, 59);
    const yearMonthTo = getStringFromDate(lastDate);

    getReportJobinTargetYearMonth(params.OrgUserId, yearMonthFrom, yearMonthTo);
  }, []);

  const authCheck = () => {
    if (!user || !user.id || user.id == "error") {
      navigate("/SignIn");
      return false;
    }
    return true;
  };
  authCheck();

  const columns = [
    {
      field: "Created",
      headerName: "日付",
      width: 180,
    },
    {
      field: "GroupName",
      headerName: "グループ名",
      width: 180,
    },
    {
      field: "NickName",
      headerName: "表示名",
      width: 180,
    },
    {
      field: "Userid",
      headerName: "システムID",
      sortable: false,
      width: 220,
    },
  ];

  return (
    <div className="asset-list-root">
      <AccountMenu />
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item md={4}>
              <Typography variant="h5">
                {year}年{month}月&nbsp;利用明細
              </Typography>
            </Grid>
            <Grid item md={8}>
              <Typography variant="body2">
                ※初回ダウンロード時のみ課金対象となります。
                <br />
                ※ひと月内に何度印刷されても費用は加算されません。
              </Typography>
            </Grid>
          </Grid>

          <div
            style={{
              width: "100%",
              marginTop: "20px",
            }}
          >
            <DataGrid
              rows={
                reports
                  ? Object.values(
                      reports.reduce((acc, row) => {
                        if (
                          !acc[row.Userid] ||
                          row.Created < acc[row.Userid].Created
                        ) {
                          acc[row.Userid] = row;
                        }
                        return acc;
                      }, {})
                    ).sort((a, b) => (b.Created > a.Created ? 1 : -1))
                  : []
              }
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10]}
              checkboxSelection={false}
              disableSelectionOnClick
              density="compact"
              autoHeight
            />
          </div>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Button variant="outlined" onClick={() => navigate(-1)}>
              戻る
            </Button>
          </Box>
          <Box sx={{ mb: 4 }} />
        </Box>
      </Container>
    </div>
  );
}
